/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';
import { uiSchemaProperties } from '../../shared/enums/uiSchemaProperties';
import { mapEntityFields } from '../../shared/submission/entityFieldsMapper';
import { getIconComponent } from '../../shared/utils/iconUtils';

export const useSignatureCards = (submission) => {
  const { procedure, signature, signatures } = submission ?? {};

  const validationSchema = useConfiguration(ConfigResourceProps.SUBMISSION_SIGNING_VALIDATION_SCHEMA, procedure);
  const uiSchema = useConfiguration(ConfigResourceProps.SUBMISSION_SIGNING_UI_SCHEMA, procedure);

  // maintains compatibility with legacy signature
  const _signatures = signatures?.signatureItems ? signatures.signatureItems : [signature] ?? [];

  const getSignatureCardProps = (_signature, _index) => {
    const config = uiSchema.resource?.signatures?.signatureItems?.[uiSchemaProperties.UI_SUMMARY_ITEM];

    // the order property is usually handled by RJSForm (which is not the case here)
    // we have to add it so that the summary item renders successfully
    const signatureWithOrder = { ..._signature, order: _index + 1 };
    // we must provide a context to the mapEntityFields function
    // this context will contain only the submission.
    // trying to retrieve anything else from the context will result in a failed rendering.
    const context = { submission };
    const { icon, ...props } = mapEntityFields(config, signatureWithOrder, validationSchema.resource, context);
    return {
      Icon: () => getIconComponent(icon),
      ...props,
    };
  };

  return {
    signatures: uiSchema.ready && validationSchema.ready ? _signatures : [],
    getSignatureCardProps,
  };
};
